/**
 * product-card.js — نغمة ستور
 * الوظيفة الفعلية الوحيدة المحتاجة لجافاسكريبت هنا: "إضافة سريعة" حقيقية
 * (Quick Add) من بطاقة المنتج لمنتج ذي Variant واحدة متاحة فقط (انظر
 * snippets/product-card.liquid — الزر لا يُرسم أصلاً لمنتجات متعددة
 * الخيارات، فلا حاجة لأي منطق اختيار Variant هنا).
 *
 * تصحيح جولة Product Template: منطق تحديث درج السلة/عدّاد السلة وحماية
 * السباق (تسلسل الطلب + AbortController) كان مكتوبًا هنا بالكامل بينما
 * أصبح مطلوبًا أيضًا من نموذج صفحة المنتج (assets/product.js). بدل تكرار
 * نفس المنطق حرفيًا في ملفين، استُخلص إلى assets/cart-sync.js (يُحمَّل بلا
 * شرط من layout/theme.liquid كـNaghmah.cartSync)، وهذا الملف يستدعيه فقط.
 * لا تغيير في السلوك الفعلي — فقط إزالة تكرار.
 *
 * الأساس (من جولات سابقة، لم يتغيّر):
 * 1) لا روابط Ajax ثابتة إطلاقًا — الرابط يُشتق وقت التشغيل عبر
 *    Naghmah.cartSync.getRoutesRoot().
 * 2) الإضافة عبر cart/add.js بصيغة items[] الرسمية.
 * 3) بعد نجاح الإضافة، Naghmah.cartSync.refreshDrawerAndOpen يطلب المقطع
 *    الحي لـcart-drawer عبر Section Rendering API ويفتحه (أو يكتفي بتحديث
 *    العدّاد إن كان الدرج معطَّلاً).
 * 4) الفتح يمر عبر Naghmah.cartDrawer.open(button) — تمرير زر Quick Add
 *    نفسه كـtrigger يضمن إعادة التركيز إليه بعد إغلاق الدرج.
 * 5) الزر يُعاد تفعيله فورًا بعد نجاح الطلب (قبل فتح الدرج) لضمان قابليته
 *    لاستقبال التركيز إن أُغلق الدرج بسرعة.
 * 6) حالة كل زر Quick Add مستقلة عبر WeakMap (busy + resetTimer)، لا تعتمد
 *    على button.disabled وحده كحارس.
 *
 * مستمع نقر واحد مفوَّض (delegated) على مستوى document، يُربط مرة واحدة
 * فقط طوال عمر الصفحة، بنفس نمط cart-drawer.js.
 */
(function () {
  "use strict";

  var delegatedBound = false;

  var buttonState = typeof WeakMap === "function" ? new WeakMap() : null;
  var fallbackButtonState = [];

  function getButtonMeta(button) {
    if (buttonState) {
      var meta = buttonState.get(button);
      if (!meta) {
        meta = { busy: false, resetTimer: null };
        buttonState.set(button, meta);
      }
      return meta;
    }
    for (var i = 0; i < fallbackButtonState.length; i++) {
      if (fallbackButtonState[i].button === button) return fallbackButtonState[i].meta;
    }
    var entry = { button: button, meta: { busy: false, resetTimer: null } };
    fallbackButtonState.push(entry);
    return entry.meta;
  }

  function setButtonState(button, label, disabled) {
    button.textContent = label;
    button.disabled = disabled;
    button.setAttribute("aria-disabled", disabled ? "true" : "false");
  }

  function handleQuickAdd(button) {
    var meta = getButtonMeta(button);
    if (meta.busy) return;

    if (meta.resetTimer) {
      window.clearTimeout(meta.resetTimer);
      meta.resetTimer = null;
    }

    var variantId = button.getAttribute("data-variant-id");
    var addedLabel = button.getAttribute("data-added-label") || "تمت الإضافة إلى السلة";
    var errorLabel = button.getAttribute("data-error-label") || "تعذّر إضافة المنتج، حاول مرة أخرى";
    var originalLabel = button.getAttribute("data-original-label") || button.textContent;
    button.setAttribute("data-original-label", originalLabel);

    if (!variantId) return;

    var root = Naghmah.cartSync.getRoutesRoot();
    var cartAddUrl = root + "cart/add.js";

    meta.busy = true;
    button.setAttribute("data-quick-add-busy", "true");
    setButtonState(button, originalLabel, true);

    fetch(cartAddUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1
          }
        ]
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var message =
            (result.data && (result.data.description || result.data.message)) ||
            "add_to_cart_failed";
          throw new Error(message);
        }
        meta.busy = false;
        button.removeAttribute("data-quick-add-busy");
        setButtonState(button, addedLabel, false);
        Naghmah.cartSync.refreshDrawerAndOpen(root, button);
        meta.resetTimer = window.setTimeout(function () {
          setButtonState(button, originalLabel, false);
          meta.resetTimer = null;
        }, 1800);
      })
      .catch(function () {
        meta.busy = false;
        button.removeAttribute("data-quick-add-busy");
        setButtonState(button, errorLabel, true);
        meta.resetTimer = window.setTimeout(function () {
          setButtonState(button, originalLabel, false);
          meta.resetTimer = null;
        }, 2200);
      });
  }

  function bindDelegatedOnce() {
    if (delegatedBound) return;
    delegatedBound = true;

    document.addEventListener("click", function (evt) {
      var button = evt.target.closest("[data-quick-add-button]");
      if (!button) return;
      evt.preventDefault();
      handleQuickAdd(button);
    });
  }

  window.Naghmah = window.Naghmah || {};
  var Naghmah = window.Naghmah;

  if (Naghmah.registerSection) {
    Naghmah.registerSection("featured-collection", bindDelegatedOnce);
    Naghmah.registerSection("category-showcase", bindDelegatedOnce);
    Naghmah.registerSection("main-collection-product-grid", bindDelegatedOnce);
  }

  Naghmah.onReady(bindDelegatedOnce);
})();
